import { Card, Dropdown, FloatButton, Pagination, Tooltip } from "antd";
import React from "react";
import { DownOutlined, PlusOutlined, LeftOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { formateDate } from "src/components/helpers/formateDate";
import { getLink } from "src/store/Slices/ClientsSlice";
import SureModal from "src/components/Modals/SureModal";

const MobileClientLink = ({
  page,
  setPage,
  setPageSize,
  linkInfo,
  setLinkInfo,
  clientInfo,
  getClientLinkList,
  getClientLinkListLoading,
  setIsOpenAddLinkModal,
  setTab,
  mnemo,
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Pagination
          defaultCurrent={page}
          pageSize={20}
          showSizeChanger={false}
          current={page}
          onChange={(page, pageSize) => {
            dispatch(
              getLink({
                clientId: clientInfo.id,
                count: pageSize,
                offset: pageSize * (page - 1),
              })
            );
            setPage(page);
            setPageSize(pageSize);
          }}
          total={getClientLinkList?.data?.value?.totalCount}
          page={page}
        />
        {getClientLinkList?.data?.value?.rows.map((element) => {
          return (
            <Card
              loading={getClientLinkListLoading}
              title={`Ссылка №: ${element.id}`}
              style={{ width: 330, marginTop: 16 }}
              key={element.id}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div>№:</div>
                  <div>Название клуба:</div>
                  <div>Длительность:</div>
                  <div>Тип абонемента:</div>
                  <div>Цена:</div>
                  <div>Ссылка на оплату:</div>
                  <div>Дата создания ссылки:</div>
                  <div>Статус:</div>
                </div>
                <div>
                  <div>{element?.id ? element?.id : "-"}</div>
                  <div>
                    {element?.clubName ? (
                      <Tooltip title={element?.clubName}>
                        {element?.clubName.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.monthCount ? (
                      <Tooltip title={element?.monthCount}>
                        {element?.monthCount}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.abonement ? (
                      <Tooltip title={element?.abonement}>
                        {element?.abonement.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.price ? (
                      <Tooltip title={element?.price}>{element?.price}</Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.paymentLink ? (
                      <Tooltip title={element?.paymentLink}>
                        {element?.paymentLink.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.linkCreationDate ? (
                      <Tooltip title={element?.linkCreationDate}>
                        {formateDate(element?.linkCreationDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>{element?.status ? element?.status : "-"}</div>
                </div>
              </div>
            </Card>
          );
        })}
        <FloatButton
          disabled={
            !mnemo?.children
              ?.find((el) => el.name === "Ссылки клиента")
              ?.children.find((ele) => ele.mnemo === "insertBtn")
          }
          style={{ right: 24 }}
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsOpenAddLinkModal({ open: true, flag: "add" });
          }}
        />
        <FloatButton
          style={{ left: 24 }}
          type="primary"
          icon={<LeftOutlined />}
          onClick={() => {
            setTab("Клиенты");
          }}
        />
      </div>
    </>
  );
};

export default MobileClientLink;
